
import member from '../../api/member/memberinfo'
const namespaced = true

const state = {
    token: '',
    user: null,
    active: 'Home',
    is_show: false,
    source: 1,
    positions: [],
    eq_show:false
}

const getters = {

}

const mutations = {
    token (state, token) {
        state.token = token
        Lockr.set('token', token)
    },
    user (state, user) {
        state.user = user
        Lockr.set('user', user)
    },
    active (state, active) {
        state.active = active
    },
    show (state, is_show) {
        state.is_show = is_show
    },
    source (state, source) {
        state.source = source
    },
    position (state, payload) {
        state.positions[payload.name] = payload.position
    },
    eqshow(state, eq_show){
        state.eq_show = eq_show
    },
}

const actions = {
    setToken({ commit, dispatch, state }, token) {
        commit('token', token)
        axios.defaults.headers.common = {
          'X-Requested-With': 'XMLHttpRequest',
          'Authorization': `Bearer ${token}`
        }
        if(!state.user)
            dispatch('getUser')
    },
    setSource({ commit }, source) {
        commit('source', source)
    },
    getUser({ commit }) {
        return new Promise((resolve, reject) => {
            member.getMemberInfo().then(res => {
                if(res.data.state == 1) {
                    commit('user', res.data.data)
                    resolve(res)
                }
            })
        }, err => {
            reject(err)
        })
    }
}

export default {
    namespaced,
    state,
    getters,
    mutations,
    actions
}